module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE4IDE0Ij4KICAgIDxwYXRoIGZpbGw9IiNGRkI5NTMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE4IDEydjJIMHYtMmgxOHptMC02djJIMFY2aDE4em0wLTZ2MkgwVjBoMTh6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/hamburger.svg
// module id = LODM
// module chunks = 6